import { render, staticRenderFns } from "./aShopDetail.vue?vue&type=template&id=a3837692&scoped=true"
import script from "./aShopDetail.vue?vue&type=script&lang=js"
export * from "./aShopDetail.vue?vue&type=script&lang=js"
import style0 from "./aShopDetail.vue?vue&type=style&index=0&id=a3837692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3837692",
  null
  
)

export default component.exports